/**
 * Règles de mot de passe côté client. Elles REFLÈTENT celles du serveur
 * (`internal/domain/account/password.go` : au moins 12 caractères, aucune règle
 * de composition) et ne les remplacent pas : le serveur a le dernier mot, ici
 * on évite seulement un aller-retour évident.
 */

/** Longueur minimale, en caractères. Même valeur que `account.MinPasswordRunes`. */
export const MIN_LONGUEUR = 12;

export type EvaluationMotDePasse = {
  /** Nombre de caractères (et non d'octets). */
  longueur: number;
  /** Vrai quand le serveur l'acceptera. */
  valide: boolean;
  /** Robustesse indicative, de 0 à 4, pour la jauge. */
  force: 0 | 1 | 2 | 3 | 4;
};

/** Évalue un mot de passe. */
export function evaluerMotDePasse(mdp: string): EvaluationMotDePasse {
  const longueur = Array.from(mdp).length;
  const valide = longueur >= MIN_LONGUEUR;
  let force: 0 | 1 | 2 | 3 | 4 = 0;
  if (longueur >= MIN_LONGUEUR) force = 1;
  if (longueur >= 16) force = 2;
  if (longueur >= 20) force = 3;
  if (longueur >= 24) force = 4;
  return { longueur, valide, force };
}

/** Message d'erreur affichable, ou `null` si le mot de passe passe. */
export function erreurMotDePasse(mdp: string): string | null {
  if (mdp.length === 0) {
    return "Choisissez un mot de passe.";
  }
  const { longueur } = evaluerMotDePasse(mdp);
  if (longueur < MIN_LONGUEUR) {
    return `Encore ${MIN_LONGUEUR - longueur} caractère${MIN_LONGUEUR - longueur > 1 ? "s" : ""} : il en faut au moins ${MIN_LONGUEUR}.`;
  }
  return null;
}

/** Message d'erreur de la confirmation, ou `null`. */
export function erreurConfirmation(mdp: string, confirmation: string): string | null {
  if (confirmation.length === 0) {
    return "Saisissez le mot de passe une seconde fois.";
  }
  return mdp === confirmation ? null : "Les deux mots de passe diffèrent.";
}

/** Lit le jeton d'un lien reçu par courriel : il voyage dans le fragment. */
export function jetonDuFragment(hash: string): string | null {
  const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
  const token = params.get("token");
  return token && token.length > 0 ? token : null;
}
